<template>
  <div class="LKPublicationsDataCollectionLeft__col--left">
    <div class="LKPublicationsDataCollectionLeft__bottom">
      <div
        v-if="!(curator || expert || spectator)"
        :class="statusStyle"
        class="LKPublicationsDataCollectionLeft__status"
        v-text="statusText"
      />

      <div
        class="LKPublicationsDataCollectionLeft__date"
        v-text="dates"
      />
    </div>

    <div
      v-if="description"
      class="LKMunMehCardFormLeft__bottom-text"
      v-html="description"
    />
  </div>
</template>


<script>
import LKPublicationsDataCollectionLeft
  from '@/views/LKPublications/components/LKPublicationsDataCollection/LKPublicationsDataCollectionLeft.vue'
import { dateFormatter, uiDateFormatter } from '@/helpers/dateFormatter'
import { MunMehFormStatuses } from '@/typings/api/MunMeh'

const DATE_FORMAT = 'D MMMM YYYY, HH:mm'

export default {
  name: 'LKMunMehCardFormLeft',
  extends: LKPublicationsDataCollectionLeft,
  props: {
    data: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    expert: Boolean,
    curator: Boolean,
    spectator: Boolean,
  },
  computed: {
    formStatus() {
      const { data, disabled } = this
      return data.form?.status
          || (disabled ? MunMehFormStatuses.not_done : MunMehFormStatuses.not_started)
    },
    dates() {
      const { data } = this

      return [
        dateFormatter(data.start_at, DATE_FORMAT),
        dateFormatter(data.end_at, DATE_FORMAT),
      ].filter(Boolean).join(' - ') || 'Дата проведения не установлена'
    },
    statusStyle() {
      const { formStatus, disabled } = this
      const checkedStatuses = [
        MunMehFormStatuses.in_progress,
        MunMehFormStatuses.submitted,
        MunMehFormStatuses.done,
        MunMehFormStatuses.not_done,
      ]

      if (checkedStatuses.includes(formStatus)) {
        return {
          'is-opened': [MunMehFormStatuses.in_progress, MunMehFormStatuses.submitted].includes(formStatus),
          'is-done': formStatus === MunMehFormStatuses.done,
          'is-not-done': formStatus === MunMehFormStatuses.not_done,
        }
      }
      return {
        'is-opened': !disabled,
        'is-disabled': disabled,
      }
    },
    statusText() {
      const { formStatus, disabled } = this

      switch (formStatus) {
        case MunMehFormStatuses.in_progress:
          return 'В работе'
        case MunMehFormStatuses.done:
        case MunMehFormStatuses.submitted:
          return 'Сдано'
        case MunMehFormStatuses.not_done:
          return 'Не сдано'
        default:
          return disabled ? 'Закрыт' : 'Открыт'
      }
    },
    description() {
      const { formStatus, disabled, data } = this

      if (this.curator) {
        return this.curatorDescription
      }

      if (disabled) {
        return 'Заполнение недоступно. <br> Прием закрыт.'
      }

      const time = data.form?.submitted_at ? ` ${uiDateFormatter(data.form.submitted_at)} (мск.)` : ''

      switch (formStatus) {
        case MunMehFormStatuses.not_started:
        case MunMehFormStatuses.in_progress:
          return 'Вы можете заполнить форму. <br> Прием открыт.'
        case MunMehFormStatuses.not_done:
          return 'Заполнение недоступно. <br> Прием закрыт.'
        case MunMehFormStatuses.submitted:
        case MunMehFormStatuses.done:
          return `Форма отправлена${time}.`
        default: return null
      }
    },
    curatorDescription() {
      const { formStatus, disabled } = this
      if (disabled) {
        return 'Прием закрыт.'
      }

      switch (formStatus) {
        case MunMehFormStatuses.not_started:
        case MunMehFormStatuses.in_progress:
        case MunMehFormStatuses.submitted:
          return 'Прием открыт.'
        case MunMehFormStatuses.not_done:
        case MunMehFormStatuses.done:
          return 'Прием закрыт.'
        default: return null
      }
    },
  },
}
</script>

<style lang="scss">
.LKMunMehCardFormLeft {
  &__bottom-text {
    margin-top: 8px;
    font-size: 12px;
    color: $webflow-color-blue-dark-2;
  }
}

.LKPublicationsDataCollectionLeft {
  &__status {
    margin-right: 12px;
  }

  &__date {
    margin-left: unset;
  }
}
</style>
